import { css, sva } from "@agapi/ui/panda/css";

export const gridStyles = css({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(token(spacing.9), 1fr))',
  gap: '4',
  alignItems: 'center',
  justifyContent: 'center',
  md: {
    gridTemplateColumns: 'repeat(auto-fill, minmax(token(spacing.10), 1fr))',
  }
});

export const cardStyles = sva({
  slots: ['root', 'image', 'title', 'overlay'],
  base: {
  root: {
    display: 'flex',
    flexDirection: 'column',
    aspectRatio: '2 / 1',
    transition: 'transform 0.2s ease-in-out',
      '&:hover': {
        transform: 'scale(1.03)',
      },
    },
    image: {
      aspectRatio: '2 / 1',
      objectFit: 'cover',
      width: '100%',
      filter: 'blur(77px)!',
    },
    title: {
      textStyle: 'h5',
      textAlign: 'center',
      lineHeight: '1.2',
      padding: '3',
    },
    overlay: {
      backgroundColor: 'surface.primary.subdued.background/60',
      width: '100%',
      height: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
    },
  }
});